<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>平台课程列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 添加 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="sousuo.title" placeholder="请输入课程标题"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="sousuo.type" placeholder="请选择课程类别">
          <el-option v-for="item in optionsS1" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="sousuo.free" placeholder="请选择费用类别">
          <el-option v-for="item in optionsS2" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="sousuo.currency" placeholder="请选择币种">
          <el-option v-for="item in optionsS4" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="审核状态">
        <el-select v-model="sousuo.status" placeholder="请选择审核状态">
          <el-option v-for="item in optionsS5" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table size="small" :data="TaskData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;margin-top: 24px;">
      <el-table-column align="center" prop="title" label="课程标题" width="120"></el-table-column>
      <el-table-column align="center" prop="description" label="课程描述" width="120"></el-table-column>

      <el-table-column align="center" prop="image" label="封面图" width="120">
        <template slot-scope="scope">
          <img v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image" />
          <div v-if="scope.row.image == null || scope.row.image == ''">
            没有图片
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center" prop="type" label="课程类别" width="120" :formatter="Type"></el-table-column> -->
      <!-- <el-table-column align="center" prop="free" label="费用类别" width="120" :formatter="Free"></el-table-column>
      <el-table-column align="center" prop="currency" label="币种" width="120" :formatter="Currency"></el-table-column>
      <el-table-column align="center" prop="amount" label="金额" width="120"></el-table-column> -->
      <!-- <el-table-column align="center" prop="status" label="审核状态" width="120" :formatter="Status"></el-table-column> -->
      <el-table-column align="center" prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="400">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="getTaskxq(scope.row)">查看课程详情</el-button>
          <el-button size="mini" type="primary" @click="taskToVideo(scope.row)">查看视频详情</el-button>
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleShow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 课程详情 -->
    <el-dialog title="课程管理详情页：" :visible.sync="editFormDetails">
      <el-form label-width="120px">
        <el-form-item label="课程标题：">
          <span v-html="this.Details.title"></span>
        </el-form-item>
        <el-form-item label="课程描述：">
          <span v-html="this.Details.description" style="display: block; width: 100%"></span>
        </el-form-item>
        <el-form-item label="封面图：">
          <el-image v-if="this.Details.image" style="width: 140px;margin-left: 14px;" :src="this.Details.image"
            :preview-src-list="[this.Details.image]" />
          <span v-else>没有图片</span>
        </el-form-item>
        <el-form-item label="审核状态：">
          <span v-if="this.Details.status == 0">待审核</span>
          <span v-if="this.Details.status == 1">审核通过</span>
          <span v-if="this.Details.status == 2">审核中</span>
        </el-form-item>
        <el-form-item label="创建时间：" v-if="this.Details.createTime">
          {{ transformDate(this.Details.createTime) }}
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 编辑界面 -->
    <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
      <el-form label-width="120px">
        <el-form-item label="课程标题">
          <el-input size="small" v-model="title" placeholder="请输入课程标题"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input size="small" v-model="description" placeholder="请输入描述"></el-input>
        </el-form-item>
        <!-- <el-form-item label="课程类别">
          <el-select v-model="taskValue" placeholder="请选择课程类别">
            <el-option v-for="item in taskOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="封面图">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="image != ''" :src="image" style="width: 140px;height: 140px;margin-left: 14px;" />
          </div>
        </el-form-item>

        <!-- <el-form-item label="详情图" prop="url" v-if="taskValue == 0">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgTwoUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="url != ''" :src="url" style="width: 140px;height: 140px;margin-left: 14px;" />
          </div>
        </el-form-item> -->

        <!-- <el-form-item label="视频" prop="url" v-if="taskValue == 1">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainVideoUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <video :src="url" style="width: 80px;margin-left: 14px;" v-if="url" controls>
              Your browser does not support the video tag.
            </video>
          </div>
        </el-form-item> -->

        <!-- <el-form-item label="费用类别">
          <el-select v-model="freeValue" placeholder="请选择费用类别">
            <el-option v-for="item in freeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种" v-if="freeValue == 1 || freeValue == 2">
          <el-select v-model="currencyValue" placeholder="请选择币种">
            <el-option v-for="item in currencyOption" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖学金" prop="amount" v-if="freeValue != 0 && currencyValue == 0">
          <el-input size="small" v-model="amount" placeholder="请输入奖学金"></el-input>
        </el-form-item>
        <el-form-item label="钻石" prop="amount" v-if="freeValue != 0 && currencyValue == 1">
          <el-input size="small" v-model="amount" placeholder="请输入钻石"></el-input>
        </el-form-item> -->

        <!-- <el-form-item :label="item.name" v-for="(item, tagIndex) in taskTag" :key="tagIndex">
          <el-input size="small" v-model="item.score" placeholder="请输入分值"></el-input>
        </el-form-item> -->
        <el-form-item label="排序">
          <el-input size="small" v-model="sort" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addTaskFn()" v-if="tit == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="upTask()" v-if="tit == '修改'">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTaskList,
  getTaskInfo,
  addTask,
  aduitTask,
  deleteTask,
  upTask,
  getTaskTagList
} from "../../api/userMG";
import client from "@/utils/ossClient.js";

export default {
  data() {
    return {
      optionsS1: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '图文'
        }, {
          value: 1,
          label: '视频'
        }],
      optionsS2: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '免费'
        }, {
          value: 1,
          label: '收费'
        }, {
          value: 2,
          label: '奖励'
        }],
      optionsS4: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '奖学金'
        }, {
          value: 1,
          label: '钻石'
        }],
      optionsS5: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 0,
          label: '待审核'
        }, {
          value: 1,
          label: '审核通过'
        }, {
          value: 3,
          label: '审核中'
        }],
      TaskData: [],
      sousuo: {
        title: '',
        type: -1,
        free: -1,
        currency: -1,
        status: -1,
        mobile: '',
        nickName: ''
      },
      title: "",
      description: "",
      image: "",
      url: "",
      type: -1,
      free: -1,
      kind: 0,
      currency: -1,
      id: '',
      amount: "",
      status: -1,
      mobile: "",
      nickName: "",
      editFormDetails: false,
      Details: [],
      editFormVisiible: false,
      taskOption: [
        {
          value: "0",
          label: "图文"
        },
        {
          value: "1",
          label: "视频"
        }
      ],
      taskValue: "0",
      freeOption: [
        {
          value: "0",
          label: "免费"
        },
        {
          value: "1",
          label: "收费"
        },
        {
          value: "2",
          label: "奖励"
        }
      ],
      freeValue: "0",
      createTypeOption: [
        {
          value: "0",
          label: "平台"
        }
      ],
      currencyOption: [
        {
          value: "0",
          label: "奖学金"
        },
        {
          value: "1",
          label: "钻石"
        }
      ],
      currencyValue: "0",

      tit: "添加",
      taskTag: [],
      sort: ""
    };
  },
  created() {
    this.getData(1);
    this.getTaskTagListFn();
  },
  methods: {
    // 跳转页面
    taskToVideo(row) {
      setTimeout(() => {
        this.loading = false
        // 跳转页面
        this.$router.push({
          path: '/task/TaskToVideo', query: {
            id: row.id
          }
        })
      })
    },
    closeDialog() {
      this.editFormVisiible = false;
    },
    clearFn() { },
    handleEdit(row) {
      this.editFormVisiible = true;
      if (row != undefined && row != "undefined") {
        this.tit = "修改";
        this.title = row.title;
        this.id = row.id;
        this.description = row.description;
        this.image = row.image;
        // this.url = row.url;
        // this.amount = row.amount;
        // this.taskValue = row.type.toString();
        // this.freeValue = row.free.toString();
        // this.currencyValue = row.currency.toString();
        // this.freeValue = row.free.toString();
        this.sort = row.sort;
        // this.taskTag = JSON.prase(row.tagId);
        // console.log("row======", row);
      } else {
        this.tit = "添加";
        // this.taskValue = "";
        // this.freeValue = "0";
        // this.currencyValue = "0";
        // this.freeValue = "0";
        this.title = "";
        this.description = "";
        this.image = "";
        this.sort = '';
        // this.url = "";
        // this.amount = "";
        // this.taskTag.forEach(item => {
        //   item.score = "";
        // });
      }
    },
    deleShow(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteTask(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getData(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addTaskFn() {
      console.log("tagid", this.taskTag);
      let tagId = [];
      this.taskTag.forEach(item => {
        tagId.push({
          id: item.id,
          name: item.name,
          score: item.score
        });
      });

      let data = {
        title: this.title,
        description: this.description,
        image: this.image,
        // url: this.url,
        // type: this.taskValue,
        // free: this.freeValue,
        // kind: 0,
        // currency: this.currencyValue,
        // amount: this.amount || 0,
        // tagId: JSON.stringify(tagId),
        sort: this.sort
      };
      addTask({
        ...data
      }).then(res => {
        console.log("res=======", res);
        this.editFormVisiible = false
        if (res.code == 200) {
          this.getData(1);
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    upTask() {
      let tagId = [];
      this.taskTag.forEach(item => {
        tagId.push({
          id: item.id,
          name: item.name,
          score: item.score
        });
      });

      let data = {
        title: this.title,
        description: this.description,
        image: this.image,
        // url: this.url,
        // type: this.taskValue,
        // free: this.freeValue,
        // kind: 0,
        // currency: this.currencyValue,
        // amount: this.amount || 0,
        // tagId: JSON.stringify(tagId),
        sort: this.sort,
        id: this.id
      };

      upTask({
        ...data
      }).then(res => {
        this.editFormVisiible = false

        if (res.code == 200) {
          this.getData(1);
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getTaskTagListFn() {
      getTaskTagList().then(res => {
        console.log("res");
        if (res.code == 200) {
          this.taskTag = res.data.list;
        }
      });
    },
    // 自定义上传方法 图片的
    mainImgUpload(file) {
      // 判断扩展名
      this.loading=true
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then(res => {
          if (res.url) {
      this.loading=false
            this.image = res.url;
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch(err => { });
    },
    mainImgTwoUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then(res => {
          if (res.url) {
            this.url = res.url;
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch(err => { });
    },
    // 自定义上传方法 视频的
    mainVideoUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["video", "mp4"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then(res => {
          if (res.url) {
            this.url = res.url;
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch(err => { });
    },

    // 查看详情页面
    getTaskxq(row) {
      this.loading = true;
      this.editFormDetails = true;
      let data = {
        id: row.id
      };
      //   return console.log("idudddd",data.id);
      getTaskInfo(data).then(res => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Details = res.data.data;
          return;
        }
      });
    },
    // Status审核状态
    Status: function (row) {
      if (row.status == 0) {
        return " 待审核";
      } else if (row.status == 1) {
        return "审核通过";
      } else if (row.status == 2) {
        return "审核中";
      }
    },
    // Currency币种
    Currency: function (row) {
      if (row.currency == 0) {
        return "奖学金";
      } else if (row.currency == 1) {
        return "钻石";
      }
    },
    // free费用类别
    Free: function (row) {
      if (row.free == 0) {
        return "免费";
      } else if (row.free == 1) {
        return "收费";
      } else if (row.free == 2) {
        return "奖励";
      }
    },
    // Type课程类别
    Type: function (row) {
      if (row.type == 0) {
        return "图文";
      } else if (row.type == 1) {
        return "视频";
      }
    },
    // 搜索数据
    search() {
      this.getData(1)
    },
    // 重置数据
    chongzhi() {
      this.sousuo.title = ''
      this.sousuo.type = -1
      this.sousuo.free = -1
      this.sousuo.currency = -1
      this.sousuo.status = -1
      this.getData(1)
    },
    // 获取数据
    getData(page) {
      this.loading = true;
      let data = {
        title: this.sousuo.title,
        type: this.sousuo.type,
        free: this.sousuo.free,
        kind: 0,
        currency: this.sousuo.currency,
        status: this.sousuo.status,
        mobile: this.sousuo.mobile,
        nickName: this.sousuo.nickName,
        page: (page - 1) * 10,
      }
      if (this.title) {
        data.title = this.title
      }
      if (this.mobile) {
        data.mobile = this.mobile
      }
      if (this.nickName) {
        data.nickName = this.nickName
      }
      getTaskList(data).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.TaskData = res.data.list;
          return;
        } else {
          this.$Message({
            type: "info",
            message: res.msg
          });
        }
      });
    },
    aduitTaskFn(row, status) {
      this.$confirm("确定当前操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(() => {
          let data = {
            id: row.id,
            status
          };
          aduitTask(data).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.getData(1);
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/task/platformTask.vue